export default __webpack_public_path__ + "static/media/background_3.a7782266.jpg";